import { React, useEffect } from "react";
import { Paper, Grid, styled } from "@mui/material";
import playBtn from "../asset/images/home/playBtn.png";
import displayVideo from "../asset/images/home/displayVideo.png";
import playerMain from "../asset/images/player/FullScreen720.png";
import todayTopList from "../asset/images/home/todayTopList.png";
import todayMixlist from "../asset/images/home/todayMixlist.png";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function Player() {
  useEffect(() => {
    document.body.style.backgroundRepeat = "repeat-y";
    document.body.style.height = "auto";
    document.getElementsByClassName("main-container")[0].style.height = "100%";
  });

  return (
    <>
      <main>
        <Grid container columns={{ xs: 4, sm: 8, md: 12 }}>
          {/* main Display */}
          <Grid item xs={6} sm={4} md={12} className="PlayerBox my-2">
            <Item className="playerImage py-0 col-md-12 col-sm-12 common-border">
              <div className="row">
                <div className="col-md-9 mainImage col-sm-12 pr-0">
                  <img className="img-fluid" src={playerMain} alt="" />
                </div>
                <div className="col-md-3 col-sm-12 leftBox">
                  <div className="row">
                    <div className="col-md-6 col-sm-6">
                      <button className="btn btn-secondary nowPlaylist">
                        Now Playing
                      </button>
                    </div>
                    <div className="col-md-6 col-sm-6 ">
                      <button className="btn btn-secondary myPlaylist">
                        My Playlists
                      </button>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-6 col-sm-6 Panelright pr-0">
                      <img
                        src={require(`../asset/images/home/more1.png`)}
                        alt=""
                      />
                    </div>
                    <div className="col-md-6 col-sm-6 bg-black text-white Panelright-right p-0">
                      <p className="mb-0">
                        | Snow | VANS <br />
                        Vansi Yoube - Dec 17,2020 <br />
                        325,977 Views - 5000 likes <br />
                        Keyword: Winter sports, snowboarding
                      </p>
                    </div>
                  </div>

                  <div className="row  marginTop-3 ">
                    <div className="col-md-6 Panelright pr-0">
                      <img
                        src={require(`../asset/images/home/more2.png`)}
                        alt=""
                      />
                    </div>
                    <div className="col-md-6 bg-black text-white Panelright-right p-0">
                      <p className="mb-0">
                        | Snow | VANS <br />
                        Vansi Yoube - Dec 17,2020 <br />
                        325,977 Views - 5000 likes <br />
                        Keyword: Winter sports, snowboarding
                      </p>
                    </div>
                  </div>

                  <div className="row  marginTop-3 ">
                    <div className="col-md-6 Panelright pr-0">
                      <img
                        src={require(`../asset/images/home/more3.png`)}
                        alt=""
                      />
                    </div>
                    <div className="col-md-6 bg-black text-white Panelright-right p-0">
                      <p className="mb-0">
                        | Snow | VANS <br />
                        Vansi Yoube - Dec 17,2020 <br />
                        325,977 Views - 5000 likes <br />
                        Keyword: Winter sports, snowboarding
                      </p>
                    </div>
                  </div>

                  <div className="row  marginTop-3">
                    <div className="col-md-6 Panelright pr-0">
                      <img
                        src={require(`../asset/images/home/more4.png`)}
                        alt=""
                      />
                    </div>
                    <div className="col-md-6 bg-black text-white Panelright-right p-0">
                      <p className="mb-0">
                        | Snow | VANS <br />
                        Vansi Yoube - Dec 17,2020 <br />
                        325,977 Views - 5000 likes <br />
                        Keyword: Winter sports, snowboarding
                      </p>
                    </div>
                  </div>

                  <div className="row marginTop-3  bg-black panel-right-col">
                    <div className="col-md-3 Panelright Panel-rightLogo pr-0 pt-0">
                      <img
                        className=""
                        src={require(`../asset/images/home/MainPlayer_Logo.png`)}
                        alt=""
                      />
                    </div>
                    <div className="col-md-3  text-white Panelright p-0">
                      <img
                        src={require(`../asset/icons/play_round.png`)}
                        alt="Play Button"
                        style={{width:"2.5em", height:"auto"}}
                      />
                    </div>

                    <div className="col-md-3  text-white Panelright p-0">
                      <img
                        src={require(`../asset/icons/squre_heart_empty.png`)}
                        alt="Like Button"
                        style={{width:"2.5em", height:"auto"}}
                      />
                    </div>
                    <div className="col-md-3  text-white Panelright p-0">
                      <img
                        src={require(`../asset/icons/info.png`)}
                        alt="More Info"
                        style={{width:"2.5em", height:"auto"}}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row row2-FirstBox ">
                <div className="col-md-6 col-sm-12 lastWidth">
                  <div className="col-md-12 pr-0  row2-FirstBox1">
                    <div className="">Reserved Space</div>
                  </div>
                  <div className="col-md-12 pr-0  row2-FirstBox2">
                    <div className="pr-0 ">
                      <div className="row LastCol">
                        <div className="col-md-2 LastCol LastChild p-0">
                          <img
                            src={require(`../asset/images/home/more1.png`)}
                            alt=""
                          />
                        </div>
                        <div className="col-md-2 LastCol LastChild p-0">
                          <img
                            src={require(`../asset/images/home/more2.png`)}
                            alt=""
                          />
                        </div>
                        <div className="col-md-2 LastCol LastChild p-0">
                          <img
                            src={require(`../asset/images/home/more3.png`)}
                            alt=""
                          />
                        </div>
                        <div className="col-md-2 LastCol LastChild p-0">
                          <img
                            src={require(`../asset/images/home/more4.png`)}
                            alt=""
                          />
                        </div>
                        <div className="col-md-2 LastCol LastChild p-0">
                          <img
                            src={require(`../asset/images/home/more6.png`)}
                            alt=""
                          />
                        </div>
                        <div className="col-md-1 LastCol LastChild6  p-0">
                          <div className="row bg-black MoreMix text-white">
                            <div className="col-md-5 mtmix-2">MORE</div>
                            <div className="col-md-7">
                              <img
                                src={require(`../asset/icons/next.png`)}
                                alt=""
                              />
                            </div>
                          </div>
                          <div className="row MoreMix bg-black text-white">
                            <div className="col-md-5 mtmix-2 ">MIX</div>
                            <div className="col-md-7 Mix">
                              <img
                                src={require(`../asset/icons/shuffle_border.png`)}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 lastWidth2">Reserevrd</div>
              </div>
            </Item>
          </Grid>

          {/* end show on mobile */}
        </Grid>
        {/* second */}
      </main>
    </>
  );
}

export default Player;
